module.exports = __webpack_public_path__ + "static/media/lock-img.8108d245.svg";